import type { CarrierLogoProps } from './types'
import LogoSvg from '../../assets/carrier-logos/passport-global-logo.svg?react'
import { chakra } from '../../chakra'
import { getLogoProps } from './use-logo-props'
import * as React from 'react'

const Logo = chakra(LogoSvg)

export const PASSPORTGLOBALLogo = React.forwardRef<SVGSVGElement, CarrierLogoProps>(
  function PASSPORTGLOBALLogo(props, ref) {
    const logoProps = getLogoProps(props)

    return <Logo {...logoProps} ref={ref} />
  },
)
